import { rpsDeliveryMethodTypes } from '../../flows/front-office/shared/utils';

export const uspsText = `USPS to Address of record - The Mutual Fund new account paperwork will be mailed to you to review, sign and return.`;

export const docuSignText = `Submit through DocuSign - The Mutual Fund new account paperwork will be sent to you electronically to review. You will receive a secure email with the paperwork for you to sign electronically. In order to access and sign the paperwork, you will receive an SMS text code.`;

export const getDisplayText = ocrDeliveryMethod => {
  if (ocrDeliveryMethod === rpsDeliveryMethodTypes.USPS) {
    return uspsText;
  }
  return docuSignText;
};
